import { ContentCardData } from '../content-card-display';
import { SearchResult } from '../interfaces/search.interface';
import { getImage, getProductLabelAndUrl, isPublished } from '../utils/search-results.util';

/**
 * Maps search results to content card data.
 *
 * @param results
 * @param catalog
 * @param store
 * @param showUrlsAsSearchPage
 */
export function mapContentCardData(
  results: Array<SearchResult>,
  catalog: string,
  store?: string,
  showUrlsAsSearchPage = false
): Array<ContentCardData> {
  return results.map((result) => {
    // For Articles, use 'path' as the ID since they don't have an 'id' field
    const cardId = result.document.id || result.document.path;
    
    const mappedCard = {
      title: result.document.title,
      image: getImage(result.document),
      description: result.document.description,
      contributors: result.document.contributors,
      edition: result.document.EDITION || result.document.edition,
      publicationDate: result.document.publicationDate,
      documentType: result.document.documentType,
      copyRightYear: result.document.copyrightYear ? result.document.copyrightYear.toString() : '',
      store: store,
      isbn: result.document.mhid || result.document.isbn,
      isbn13: result.document.isbn13,
      netPrice: result.document.price,
      gradeLevels: result.document.gradeLevels,
      instructorOnly: result.document.instructorOnly,
      isPublished: isPublished(result.document.publicationDate),
      id: cardId,
      programSourceId: cardId,
      mhid: result.document.mhid,
      relatedProducts: result.document?.RELATED_PRODUCTS,
      ...(result.document.businessUnit && { productBusinessUnit: result.document.businessUnit }),
      ...getProductLabelAndUrl(result.document, catalog, store, showUrlsAsSearchPage),
    };
    return mappedCard;
  });
}
